// 全局常量定义
export default {
    install(Vue,options){
        Vue.prototype.global = {
            baseUrl:''
        }    
    }

 }



// WEBPACK FOOTER //
// ./src/baseUrl.js